import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BaseModal } from "@whatslly/ui-components/modals/BaseModal";
import { IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import type { TemplateLanguages } from "@whatslly/types/waba/WhatsappBusinessApiTemplate";
import { TemplatePhonePreview } from "./TemplatePhonePreview";
import styles from "./EditTemplateModal.module.scss";

type PreviewTemplateModalProps = IModalInstance<Record<string, never>> & {
  template: TemplateLanguages;
};

export const PreviewTemplateModal: React.FC<PreviewTemplateModalProps> = ({ closeModal, template }) => {
  const { t } = useTranslation();
  const languages = template.languages ?? [];
  const [selectedIdx, setSelectedIdx] = useState(0);
  const selectedLanguage = languages[selectedIdx];

  return (
    <BaseModal
      testId="preview-template-modal"
      header={
        <ModalHeader closeModal={() => closeModal()}>
          {t("whatsapp_business_api_settings_page.preview_template.title", { name: template.name })}
        </ModalHeader>
      }
      closeModal={closeModal}
      closeOnClickOutside={true}
      closeOnEscape={true}
      className={styles.previewModal}
      bodyClassName={styles.previewModalBody}
    >
      {languages.length > 1 && (
        <div className={styles.languageTabs}>
          {languages.map((lang, idx) => (
            <button
              key={lang.language}
              data-testid={`language-tab-${lang.language}`}
              className={`${styles.languageTab} ${idx === selectedIdx ? styles.languageTabActive : ""}`}
              onClick={() => setSelectedIdx(idx)}
            >
              {t(`whatsapp_business_api_agent_page.template_langs.${lang.language}`, { defaultValue: lang.language })}
            </button>
          ))}
        </div>
      )}
      <div className={styles.previewModalContent}>
        <TemplatePhonePreview components={selectedLanguage?.components} />
      </div>
    </BaseModal>
  );
};
